import { getB2BUrlByEnv } from './getB2BUrlByEnv';
import { OAUTH_CODE_STATE_ERROR_FIELDS } from './oauth';

export const GSC_SERVICE_NAME = 'Google Search Console';

/** URL для подключения Google Search Console через OAuth */
export const GOOGLE_OAUTH_API_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

/** Путь для обработки OAuth-колбека Google Search Console (зарегистрирован в Google как redirect_uri) */
export const GSC_OAUTH_CALLBACK_PATH = '/gsc/integration';

/* Redirect URI для OAuth Google Search Console */
export const getGscRedirectStaticUri = () => getB2BUrlByEnv(GSC_OAUTH_CALLBACK_PATH);

/* Ключ для идентификации OAuth-параметров Google Search Console */
export const GSC_OAUTH_STORAGE_KEY = 'gsc-oauth-params';

export const GSC_OAUTH_COOKIE_FIELDS = OAUTH_CODE_STATE_ERROR_FIELDS;
